// extracted by mini-css-extract-plugin
export default {"userInfoField":"user-info-field__HTgPN09b"};